import React, { useRef, useState } from "react";
import { Form, ProgressBar, Spinner } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import CustomRadioButton from "../../../../../../components/CustomRadioButton";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { usePostProductPriceOptionsMutation } from "../../../../../../rtk-query/slices/createProduct/ProductScheduleAndPricing/productScheduleAndPricingSlice";
import Select, { components } from "react-select";
import { generateTypes } from "../../../../../../helpers/numberOfUsers";
import { Icon } from "@iconify/react/dist/iconify.js";

// Validation schema for Formik
const validationSchema = Yup.object().shape({
  optionName: Yup.string().required("Option name is required"),
  priceType: Yup.number().required("Price type is required"),
  number: Yup.object({
    value: Yup.number()
      .required("Maximum number of travelers is required")
      .min(1, "Number must be greater than 0"),
  }).required("Maximum number of travelers is required"),
});

const PSstepOne = ({
  setStep,
  setPriceType,
  productDetail,
  productId,
  stepOneData,
  setStepOneData,
}) => {
  const navigate = useNavigate();
  const formikRef = useRef(null); // Create a reference to Formik
  const [postProductPriceOptions, { isLoading }] =
    usePostProductPriceOptionsMutation();
  const [selected, setSelected] = useState(stepOneData?.priceType || null);
  const types = generateTypes({
    selectedType: selected,
    limit: productDetail?.data?.daily_max_capacity_shared,
  });

  const handleSelect = (option, setFieldValue) => {
    setSelected(option === selected ? null : option);
    setFieldValue("priceType", option);
    setPriceType(option);
  };

  const initialValues = {
    optionName: stepOneData?.optionName || "",
    priceType: stepOneData?.priceType || null,
    number: stepOneData?.number ? stepOneData?.number : null,
  };

  // Handle key press to restrict input
  const handleKeyDown = (event) => {
    if (["e", "E", "+", "-", "."].includes(event.key) || event.key === " ") {
      event.preventDefault();
    }
  };
  return (
    <>
      <div className="cs-ps-modal-header">
        <div className="row">
          <div className="col-md-9">
            <p className="cp-ps-form-heading">
              Let's start with how you price your product
            </p>
            <p className="cp-ps-note">
              This would be your model of pricing with an offer
            </p>
          </div>
          <div className="col-md-3 cp-ps-modal-progress-container">
            <div className="d-flex w-max align-items-center justify-content-end cp-ps-modal-progress-main">
              <ProgressBar now={50} className={"cp-ps-header-progress-bar"} />
              <p className="cp-ps-header-progress-bar-text p-0 m-0">
                1-2 Steps
              </p>
            </div>
          </div>
        </div>
      </div>

      <Formik
        innerRef={formikRef} // Pass the reference to Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={async (values) => {
          setStepOneData(values);
          setStep(2);
        }}
      >
        {({ setFieldValue, values }) => (
          <FormikForm className="cp-ps-form">
            <Form.Group controlId="optionName" className="cp-ps-form-group">
              <Form.Label className="cp-ps-form-label">Option name</Form.Label>
              <Field
                name="optionName"
                as={Form.Control}
                type="text"
                placeholder="Dune buggy dubai"
                className="ob-pi-input mt-1"
              />
              <ErrorMessage
                name="optionName"
                component="div"
                className="text-danger mt-2"
              />
            </Form.Group>

            <Form.Group className="cp-ps-form-group mt-4">
              <Form.Label className="cp-ps-form-label">
                How do you price your product?
              </Form.Label>
              <div className="cp-pc-meet-radio-group gap-1">
                <CustomRadioButton
                  label="By person"
                  isSelected={selected === 1}
                  onClick={() => handleSelect(1, setFieldValue)}
                />
                <CustomRadioButton
                  label="By vehicle/group"
                  isSelected={selected === 2}
                  onClick={() => handleSelect(2, setFieldValue)}
                />
              </div>
              <ErrorMessage
                name="priceType"
                component="div"
                className="text-danger mt-2"
              />
            </Form.Group>

            <Form.Group className="mt-3 ">
              <Form.Label className="cp-ps-form-label">
                What is the maximum number of travelers per booking?
              </Form.Label>
              <Select
                name="number"
                options={types}
                placeholder="PAX"
                className="p-0 form-control cp-ps-timeslot-select ms-0"
                value={values.number}
                onChange={(option) => {
                  setFieldValue("number", option);
                }}
                components={{
                  Control: ({ children, ...props }) => (
                    <components.Control {...props}>
                      {children}
                      <div className="select-icon">
                        <Icon icon="ic:baseline-keyboard-arrow-down" />
                      </div>
                    </components.Control>
                  ),
                }}
              />
              <ErrorMessage
                name="number"
                component="div"
                className="text-danger mt-2"
              />
            </Form.Group>
          </FormikForm>
        )}
      </Formik>
      <div className="w-100 d-flex align-items-center justify-content-center">
        <button
          type="submit"
          className="submit-btn"
          onClick={() => formikRef?.current?.handleSubmit()}
        >
          {!isLoading ? (
            "Continue"
          ) : (
            <>
              Save & Continue <Spinner size="sm" />
            </>
          )}
        </button>
      </div>
    </>
  );
};

export default PSstepOne;
